import { useState } from 'react'
import { Card, Table, Tag, Button, Space, Input, DatePicker, Select } from 'antd'
import { SearchOutlined, EyeOutlined, DownloadOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { RangePicker } = DatePicker
const { Option } = Select

const ReviewHistory = () => {
  const navigate = useNavigate()
  const [loading] = useState(false)

  const columns = [
    {
      title: '案件ID',
      dataIndex: 'caseId',
      key: 'caseId',
      render: (text: string) => <span className="font-mono">{text}</span>,
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      key: 'projectName',
    },
    {
      title: '标注员',
      dataIndex: 'annotator',
      key: 'annotator',
    },
    {
      title: '审核结果',
      dataIndex: 'result',
      key: 'result',
      render: (result: string) => {
        const colors: Record<string, string> = {
          approved: 'success',
          rejected: 'error',
          partial: 'warning',
        }
        const texts: Record<string, string> = {
          approved: '通过',
          rejected: '退回',
          partial: '部分通过',
        }
        return <Tag color={colors[result]}>{texts[result]}</Tag>
      },
    },
    {
      title: '质量评分',
      dataIndex: 'score',
      key: 'score',
      render: (score: string) => {
        const stars: Record<string, string> = {
          excellent: '⭐⭐⭐⭐⭐',
          good: '⭐⭐⭐⭐',
          qualified: '⭐⭐⭐',
          pending: '⭐⭐',
        }
        return <span>{stars[score]}</span>
      },
    },
    {
      title: '审核时间',
      dataIndex: 'reviewTime',
      key: 'reviewTime',
    },
    {
      title: '操作',
      key: 'action',
      render: () => (
        <Space>
          <Button type="link" icon={<EyeOutlined />}>查看</Button>
          <Button type="link" icon={<DownloadOutlined />}>导出</Button>
        </Space>
      ),
    },
  ]

  const mockData = [
    {
      key: '1',
      caseId: 'CASE-2024-0150',
      projectName: '某医院医疗设备采购项目',
      annotator: '张三',
      result: 'approved',
      score: 'excellent',
      reviewTime: '2026-02-22 10:30',
    },
    {
      key: '2',
      caseId: 'CASE-2024-0148',
      projectName: '某学校信息化建设项目',
      annotator: '李四',
      result: 'rejected',
      score: 'pending',
      reviewTime: '2026-02-22 09:15',
    },
    {
      key: '3',
      caseId: 'CASE-2024-0145',
      projectName: '某政府办公用品采购项目',
      annotator: '王五',
      result: 'partial',
      score: 'good',
      reviewTime: '2026-02-21 16:45',
    },
  ]

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">📜 审核历史记录</h1>
      </div>

      <Card>
        <div className="flex gap-4 mb-4">
          <Input
            prefix={<SearchOutlined />}
            placeholder="搜索案件..."
            style={{ width: 250 }}
          />
          <RangePicker />
          <Select placeholder="审核结果" style={{ width: 120 }}>
            <Option value="approved">通过</Option>
            <Option value="rejected">退回</Option>
            <Option value="partial">部分通过</Option>
          </Select>
          <Select placeholder="质量评分" style={{ width: 120 }}>
            <Option value="excellent">优秀</Option>
            <Option value="good">良好</Option>
            <Option value="qualified">合格</Option>
          </Select>
          <Button type="primary" icon={<SearchOutlined />}>查询</Button>
        </div>

        <Table
          columns={columns}
          dataSource={mockData}
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </div>
  )
}

export default ReviewHistory
